import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IonicSelectableModule } from 'ionic-selectable';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { ScrollbarThemeDirective } from 'src/app/directives/scroll-directive/scrollbar-theme.directive';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
    imports: [
        FormsModule,
        IonicModule,
        CommonModule,
        TranslateModule,
        ComponentsModule,
        ReactiveFormsModule,
        // IonicSelectableModule,
        PipesModule,
        HttpClientModule
    ],
    exports: [
        IonicModule,
        FormsModule,
        CommonModule,
        TranslateModule,
        ComponentsModule,
        ReactiveFormsModule,
        // IonicSelectableModule,
        ScrollbarThemeDirective,
        PipesModule,
        HttpClientModule
    ],
    declarations: [
        ScrollbarThemeDirective
    ]
})
export class SharedModule {
}
